import { render, staticRenderFns } from "./cpwd.vue?vue&type=template&id=3854af13&scoped=true&"
import script from "./cpwd.vue?vue&type=script&lang=js&"
export * from "./cpwd.vue?vue&type=script&lang=js&"
import style0 from "./cpwd.vue?vue&type=style&index=0&id=3854af13&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3854af13",
  null
  
)

export default component.exports